import type { StateEditFieldOptionGroupItem } from "./state-edit-field.type";
import type {
  TransitionableStateModelItem,
  TransitionableStateModelType,
} from "@/entities/state";

import { useTranslation } from "react-i18next";

import { useReferentialTypeStates } from "@/entities/referential/referential-states";

import { getStateEditFieldOptions } from "./state-edit-field.helper";

export const useGetStateEditFieldOptions = (
  type: TransitionableStateModelType,
  model: TransitionableStateModelItem
): StateEditFieldOptionGroupItem[] => {
  const { t } = useTranslation();
  const { states } = useReferentialTypeStates(type);

  return [
    {
      label: t("state:currentState"),
      options: getStateEditFieldOptions([model.state], states),
    },
    {
      label: t("state:nextStatePlural"),
      options: getStateEditFieldOptions(model.next_states, states),
    },
  ];
};
